import React from 'react'

const Text = (props) => {
  const Elem = props.as
  return (
    <Elem
      {...props}
      className={`ui gp-text ${props.group} ${props.className}`}
      style={props.style}
      ref={props.reference}
    >
      {props.children}
    </Elem>
  )
}

Text.defaultProps = {
  group: '',
  className: '',
  style: {},
  as: 'p'
}

export default Text
